function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { buildClassNames } from '../../../modules/css-helpers';
import { createOwnUpComponent } from '../../components';
import { isTableCell, OwnUpTableCell } from './cell';
import { isHeaderContext, tablePropsContext } from './context';
import { OwnUpTableRow } from './row';
import { OwnUpTableBodyStyle, OwnUpTableHeaderStyle, OwnUpTableInnerContainerStyle, OwnUpTableOuterContainerStyle, OwnUpTableStyle } from './style';
/**
 * containing div
 */

var StyledTableOuterContainer = createOwnUpComponent('div', OwnUpTableOuterContainerStyle);

var OuterContainerImpl = function OuterContainerImpl(_ref) {
  var classNames = _ref.classNames,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["classNames", "variant"]);

  var classes = buildClassNames.apply(void 0, ['ou-table__outer-container'].concat(_toConsumableArray(classNames)));
  return /*#__PURE__*/React.createElement(StyledTableOuterContainer, _extends({
    className: classes,
    variant: variant
  }, props));
};
/**
 * containing div
 */


var StyledTableInnerContainer = createOwnUpComponent('div', OwnUpTableInnerContainerStyle);

var InnerContainerImpl = function InnerContainerImpl(_ref2) {
  var classNames = _ref2.classNames,
      variant = _ref2.variant,
      props = _objectWithoutProperties(_ref2, ["classNames", "variant"]);

  var classes = buildClassNames.apply(void 0, ['ou-table__inner-container'].concat(_toConsumableArray(classNames)));
  return /*#__PURE__*/React.createElement(StyledTableInnerContainer, _extends({
    className: classes,
    variant: variant
  }, props));
};
/**
 * thead
 */


var StyledTableHead = createOwnUpComponent('thead', OwnUpTableHeaderStyle);

var HeadImpl = function HeadImpl(_ref3) {
  var classNames = _ref3.classNames,
      variant = _ref3.variant,
      props = _objectWithoutProperties(_ref3, ["classNames", "variant"]);

  var classes = buildClassNames.apply(void 0, ['ou-table__thead'].concat(_toConsumableArray(classNames)));
  return /*#__PURE__*/React.createElement(StyledTableHead, _extends({
    className: classes,
    variant: variant
  }, props));
};
/**
 * tbody
 */


var StyledTableBody = createOwnUpComponent('tbody', OwnUpTableBodyStyle);

var BodyImpl = function BodyImpl(_ref4) {
  var classNames = _ref4.classNames,
      variant = _ref4.variant,
      props = _objectWithoutProperties(_ref4, ["classNames", "variant"]);

  var classes = buildClassNames.apply(void 0, ['ou-table__tbody'].concat(_toConsumableArray(classNames)));
  return /*#__PURE__*/React.createElement(StyledTableBody, _extends({
    className: classes,
    variant: variant
  }, props));
};
/**
 * table
 */


var StyledTable = createOwnUpComponent('table', OwnUpTableStyle);

var TableImpl = function TableImpl(_ref5) {
  var classNames = _ref5.classNames,
      variant = _ref5.variant,
      props = _objectWithoutProperties(_ref5, ["classNames", "variant"]);

  var classes = buildClassNames.apply(void 0, ['ou-table__table'].concat(_toConsumableArray(classNames)));
  return /*#__PURE__*/React.createElement(StyledTable, _extends({
    className: classes,
    variant: variant
  }, props));
};
/**
 * Creates an Own Up-themed table inside of a container.
 *
 * This table accepts individual ReactNodes for its headers
 *   and data. Alternatively rows can be specified using
 *   OwnUpTableRow in order to attach click handlers or variants.
 *
 * The container allows for you to specify a maximum bounds
 *   and apply sticky headers.
 *
 * @param props - Properties that dictate the table.
 *   Note that any pass-through properties such as style will
 *     be injected into the container div.
 */


export var OwnUpTable = function OwnUpTable(_ref6) {
  var _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? [] : _ref6$variant,
      className = _ref6.className,
      headers = _ref6.headers,
      data = _ref6.data,
      props = _objectWithoutProperties(_ref6, ["variant", "className", "headers", "data"]);

  // Extract the subset of shared properties that will be given
  //   to each element in the table. This includes variants and
  //   classes.
  var classNames = className === undefined ? [] : [className];
  var variantArray = Array.isArray(variant) ? variant : [variant];
  var miniProps = {
    variant: variantArray,
    classNames: classNames
  }; // Begin building the html element

  return /*#__PURE__*/React.createElement(tablePropsContext.Provider, {
    value: miniProps
  }, /*#__PURE__*/React.createElement(OuterContainerImpl, _extends({
    variant: variantArray,
    classNames: classNames
  }, props), /*#__PURE__*/React.createElement(InnerContainerImpl, miniProps, /*#__PURE__*/React.createElement(TableImpl, miniProps, /*#__PURE__*/React.createElement(HeadImpl, {
    variant: variantArray,
    classNames: classNames
  }, /*#__PURE__*/React.createElement(isHeaderContext.Provider, {
    value: true
  }, /*#__PURE__*/React.createElement(OwnUpTableRow, {
    data: headers
  }))), /*#__PURE__*/React.createElement(BodyImpl, miniProps, // Iterate over the body rows and generate their elements
  data.map(function (row, rIndex) {
    return Array.isArray(row) ? /*#__PURE__*/React.createElement(OwnUpTableRow, {
      data: row.map(function (cell, key) {
        return isTableCell(cell) ? cell : /*#__PURE__*/React.createElement(OwnUpTableCell, {
          key: key
        }, cell);
      }),
      key: rIndex
    }) : row;
  }))))));
};